const UserEN = {
  User: {
    TITLE_ADMINISTRATION: 'User administration',
    ACCESS_PROFILE: 'Access Profile',
    USER_MANAGEMENT: 'Users Management',
    FACEBOOK: 'Facebook',
    GUEST: 'Guest',
    STATUS: 'Status',
    ACTIVE: 'Active',
    BLOCKED: 'Blocked',
    PENDING_APPROVAL: 'Awaiting approval',
    INVITE_TO_PLATAFORM: 'Invite to plataform',
    INVITED: 'Invited',
    TO_BLOCK: 'Block',
    TO_ACTIVATE: 'Activate',
    TO_REMOVE: 'Remove',
    CANCEL_INVITATION_TITLE: 'Cancel invitation',
    CANCEL_INVITATION_SUBTITLE: 'Do you really want to delete the invitation?',
    BUTTON_CONFIRM: 'Yes',
    BUTTON_NO: 'No',
    INVOKE_USER_TITLE: 'Invite user',
    INVOKE_USER_SUBTITLE: 'Who do you want to invite?',
    SAVE: 'Save',
    BUTTON_CANCEL: 'Cancel',
    EMPLOYEE: 'Employee',
    ADMIN: 'Admin',
    CREATE_USER_SUCCESS_MESSAGE: 'User created successfully!',
    CREATE_USER_ERROR_MESSAGE: 'Failed to create user!',
    INVITE_USER_SUCCESS_MESSAGE: 'Invitation sent successfully!',
    INVITE_USER_ERROR_MESSAGE: 'Failed to send invitation to user!',
    INVITE_USER_ERROR_MESSAGE_USER_ALREADY_EXISTS:
      'This user has already been invited to the system.',
    REVOKE_INVITE_SUCCESS_MESSAGE: 'Invitation canceled successfully!',
    REVOKE_INVITE_ERROR_MESSAGE: 'Failed to cancel invitation sending!',
    EDIT_USER_ROLE_SUCCESS_MESSAGE: 'Role changed successfully!',
    EDIT_USER_ROLE_ERROR_MESSAGE: 'Failed to change user role!',
    EDIT_USER_GROUP_SUCCESS_MESSAGE: 'Group changed successfully!',
    EDIT_USER_GROUP_ERROR_MESSAGE: 'Failed to change user group!',
    EDIT_USER_PERMITTED: 'Edit user permitted',
    ROLE: 'Role',
    ROLE_GROUP: 'Group',
    ROLE_EMAIL: 'Email',
    ROOT_GROUPS: 'All',
    PLACEHOLDER: 'Search group',
    NO_FOUND: 'No items found',
    ACTUAL_GROUP: 'Actual group',
    NEW_GROUP: 'New group',
    PERMITTED_GROUPS: 'Permitted groups',
    ADD_PERMITTED_GROUPS: 'Add permitted group',
    PENDING: 'Pending',
    USER_ACCESS_STEP_NOT_STARTED: 'Not started',
    USER_ACCESS_STEP_SET_EMAIL: 'Filling email',
    USER_ACCESS_STEP_SET_PAGE_SCOPED_TOKEN: 'Page token authorization',
    USER_ACCESS_STEP_SET_PAGE: 'Selecting Page',
    USER_ACCESS_STEP_SET_PRIVATE_AD_ACCOUNT: 'Selecting Ad Account',
    USER_ACCESS_STEP_SET_PRIVATE_AD_ACCOUNT_PAYMENT_METHOD: 'Selecting Payment method',
    USER_ACCESS_STEP_SHOW_PENDING_REQUESTS: 'Waiting for BM requests approval',
    USER_ACCESS_STEP_WAITING_PLATFORM_SETUP: 'Waiting for automatic platform setup',
    USER_ACCESS_STEP_PENDING_PLATFORM_INVITATION: 'Waiting Platform invitation',
    USER_ACCESS_STEP_FINISHED: 'Finished',
    ALL: 'All',
    Role: 'Role',
    EDIT: 'Edit',
    EDIT_CAPABILITIES_SUCCESS_MESSAGE: 'Capabilities changed successfully!',
    EDIT_CAPABILITIES_ERROR_MESSAGE: 'Failed to change capabilities!',
    PERMISSIONS: 'Permissions',
    PROFILE: 'Profile',
    REPORT: 'Reports',
    BOOSTED_VIDEO: 'Boosted video',
    USERS: 'Users management',
    FB_BUSINESS: 'Facebook business manager',
    SETTINGS: 'Settings',
    PINNED_ASSETS: 'Pinned assets',
    CONVERSION_FLOW: 'Conversion Flow',
    CONVERSION_FLOW_DESC: 'Report with conversion metrics',
    REVIEWS: 'Reviews',
    BATCH_ACTIONS: 'Batch actions',
    NEWS: 'News',
    REPORT_LIST: 'Report list',
    APPROVAL: 'Automatic approval',
    APPROVAL_DESC: 'All content created via APP is automatically approved.',
    EMPTY_CONTENT_MESSAGE: 'No users found.',
    RESEND_INVITE: 'Resend invitation',
    'BLOCK-USER-TITLE': 'Are you sure you want to block this user?',
    'BLOCK-USER-BM': 'Delete user from Business Manager',
    'UNBLOCK-USER-TITLE': 'Are you sure you want to unblock this user?',
    'UNBLOCK-USER-BM': 'Add user to Business Manager',
    UNBLOCK: 'Unblock',
    TOTAL: 'TOTAL',
    'ACTIVE-SUMMARY': 'ACTIVES',
    'IN-PROGRESS-SUMMARY': 'IN PROGRESS',
    'INVITED-SUMMARY': 'INVITED',
    'BLOCKED-SUMMARY': 'BLOCKED',
    MANAGEMENT: 'Management',
    CREATION: 'Creation',
    APP: 'App GD',
    default_user: 'Employee',
    CAPABILITIES: 'Permissions',
    REPORT_DESC:
      "Overall health of the unit, group or all groups, according to the user's access level, with budgets, impressions, etc.",
    REPORT_ITEM: 'Overview',
    ENGAGEMENT: 'Engagement',
    ENGAGEMENT_DESC: 'Report with engagement metrics.',
    VIDEO_VIEW: 'Video View',
    VIDEO_VIEW_DESC:
      'Report with performance metrics of video content production, video engagement, percentage of viewing, etc.',
    ACTIVITY: 'Activity',
    ACTIVITY_DESC:
      'Activity of the stores in the project, such as the amount of content produced, monthly average, percentage of the format, active units and connected users.',
    REPORT_RANKING: 'Ranking',
    REPORT_RANKING_DESC: 'Report to compare the performance, in different metrics, of the units.',
    REPORT_AUDIENCE: 'Audience',
    REPORT_AUDIENCE_DESC: 'Analysis of Age, Gender, Channels and Devices of the public.',
    REPORT_COMMENTS: 'Comments',
    REPORT_COMMENTS_DESC:
      'Comments report on publications of the units., with time metrics and responses percentages.',
    LEAD_ADS: 'Lead Ads',
    LEAD_ADS_DESC: 'Report of results of the ads with the objective of capturing Leads.',
    GENERAL_LISTING: 'General Listing',
    GENERAL_LISTING_DESC:
      'Visualization of the groups in the form of a list, with the possibility of access to adapt the platform to the data of that group.',
    MANAGE_GROUPS: 'Manage Grupos',
    MANAGE_GROUPS_DESC:
      'Allows you to move, delete, rename a group, manage accounts, and replace page IDs.',
    USER_MANAGE: 'Manage Users',
    USER_MANAGE_DESC: 'Allows you to edit user permissions.',
    USER_INVITE: 'User Invite',
    USER_INVITE_DESC: 'Gives the ability to add users and block active users.',
    ADACCOUNT_BUDGET: 'Budget',
    ADACCOUNT_BUDGET_DESC: 'View the budget limit of the ad accounts.',
    BUDGET_SPEND_CAP: 'Manage group budget',
    BUDGET_SPEND_CAP_DESC: 'Allows you to deposit or remove funds from units.',
    BATCH_BUDGET_SPEND_CAP: 'Mass budget distribution',
    BATCH_BUDGET_SPEND_CAP_DESC:
      'Allows you to distribute the available funds to several units at once',
    USER_INFO: 'Edit User Profile',
    USER_INFO_DESC: 'Edit my user profile in GD.',
    TRENDS: 'Trends',
    TRENDS_DESC: 'View trends',
    MEDIA_SETS_UPLOAD: 'Upload Media Sets',
    MEDIA_SETS_UPLOAD_DESC: 'Upload Media Sets',
    UNIT_SCORE: 'Unit Score',
    UNIT_SCORE_DESC: 'View unit score',
    USER_LISTING: 'User listing',
    USER_LISTING_DESC: 'View all user accounts',
    USER_PROFILE: 'View User Profile',
    USER_PROFILE_DESC: 'View my user profile in GD.',
    EDIT_AD: 'Ad Editing',
    EDIT_AD_DESC:
      'Allows editing in: period of circulation, budget, campaing objective and pause ads.',
    FEED: 'Feed',
    FEED_DESC: 'Access to the feed of posts and ads.',
    CDA: 'Dynamic Creatives',
    CDA_DESC: 'Allows the distribution of customized media between units and groups.',
    FEED_AWARDS: 'Sort by awards in the Feed',
    FEED_AWARDS_DESC: 'It makes it possible to sort the ads by award.',
    MEDIA_SETS: 'Media Library',
    MEDIA_SETS_DESC: 'Allows to receive media files in the library.',
    BATCH_PROMOTE: 'Promote',
    BATCH_PROMOTE_DESC: 'Allows to mass promote posts or ads.',
    BATCH_REPLICATE: 'Replicate',
    BATCH_REPLICATE_DESC: 'Allows to mass replicate posts or ads.',
    BATCH_UPDATE_PROFILE_COVER: 'Change profile and cover in bulk',
    BATCH_UPDATE_PROFILE_COVER_DESC:
      'Allows you to change the profile photo and page cover by the platform.',
    MEDIA_APPROVAL: 'Control of produced content',
    MEDIA_APPROVAL_DESC: 'Allows to approve or disapprove the media coming from the APP',
    AUTO_APPROVAL: 'Automatic approval',
    AUTO_APPROVAL_DESC: 'All content created via APP is automatically approved.',
    SUGGEST_APPROVAL: 'Post Type',
    SUGGEST_APPROVAL_DESC:
      'Allows the APP user to define whether the content will be paid or organic and configure it',
    SELLER_REACH: 'Reach',
    SELLER_REACH_DESC: 'Allows to visualize the Ads metrics on the feed page.',
    SELLER_BUDGET_SPEND_CAP: 'Budget',
    SELLER_BUDGET_SPEND_CAP_DESC: 'Allows to see the budget for the ad account.',
    SELLER_MEDIA_SETS: 'Media Library',
    SELLER_MEDIA_SETS_DESC: 'Allows to receive media files in the library.',
    SELLER_INSTAGRAM: 'Posts on Instagram',
    SELLER_INSTAGRAM_DESC: 'Allows to create posts on Instagram through the app.',
    SELLER_TARGET_SELECTION: 'Target Selection',
    SELLER_TARGET_SELECTION_DESC:
      'Allows to select the target audience during the creation of each ad.',
    SELLER_PICTURE_CHANGE: 'Pictures Change',
    SELLER_PICTURE_CHANGE_DESC: 'Allows to change the facebook profile and page cover images.',
    SELLER_WHATSAPP: 'Whatsapp Contact',
    SELLER_WHATSAPP_DESC: 'Allows to change the Whatsapp number from a page.',
    SELLER_VIEW_COMMENTS: 'Comments',
    SELLER_VIEW_COMMENTS_DESC: 'Allows to read the comments on a Facebook page.',
    SELLER_RESPOND_TO_COMMENTS: 'Interactions',
    SELLER_RESPOND_TO_COMMENTS_DESC: 'Allows to interact with the comments on a Facebook page.',
    MEDIA_SET_MANAGE: 'Manage Media Library',
    MEDIA_SET_MANAGE_DESC: 'Allows to create, delete and share medias between groups and unities.',
    GDTV: 'GDTV',
    GDTV_DESC: 'Allows to access medias shared via GDTV.',
    GDTV_MANAGE: 'Manage GDTV',
    GDTV_MANAGE_DESC:
      'Allows to upload and delete medias shared via GDTV. All the produced contents will be accessible using the feed.',
    SELLER_CAROUSEL: 'Carousel',
    SELLER_CAROUSEL_DESC:
      'Possibility of creating a single ad with up to ten images or videos, each media with its own title, description and link.',
    SELLER_MULTI_IMAGE: 'Multi image',
    SELLER_MULTI_IMAGE_DESC:
      'Allows you to make postings and announcements with more than one image or video.',
    VIEW_LEADS_REPORT: 'View leads report',
    VIEW_LEADS_REPORT_DESC:
      'Report with results of the ads with the objective of generating leads, with metrics such as total leads and conversion leads.',
    DOWNLOAD_LEADS_LIST: 'Download leads list',
    DOWNLOAD_LEADS_LIST_DESC:
      'Allows you to download the spreadsheet with the data of the leads from the lead campaign.',
    SELLER_LEADS: 'Leads',
    SELLER_LEADS_DESC: 'Allows you to create lead campaigns with the purpose of generating leads',
    SELLER_DOWNLOAD_LEADS: 'Download lead ads',
    SELLER_DOWNLOAD_LEADS_DESC:
      'Allows you to download the spreadsheet with the data of the registered leads from the lead campaign in the app.',
    SELLER_VIEW_LEADS_REPORT: 'View leads report',
    SELLER_VIEW_LEADS_REPORT_DESC:
      'Report with results of the ads with the objective of generating leads, with metrics such as total leads and conversion leads.',
    CREATE_INCENTIVE_CAMPAIGN_FIXED_BUDGET: 'Fixed budget incentive campaigns',
    CREATE_INCENTIVE_CAMPAIGN_FIXED_BUDGET_DESC:
      'Allows the creation of incentive campaigns from a fixed budget.',
    REPORT_CUSTOM: 'Custom',
    REPORT_CUSTOM_DESC: 'Custom Roport',
    CALENDAR: 'Calendar of Actions',
    CALENDAR_DESC:
      'Allows you to create, change and remove events related to content, posts, education and goals.',
    CATEGORIZE_NEW_POST: 'Product categorization',
    CATEGORIZE_NEW_POST_DESC: 'Allows you to tag which category the advertised product falls into.',
    USERS_FILTERS_INPUT_PLACEHOLDER: 'Search by name or email',
    SELECT_ROLE: 'Select a role',
    SELECT_GROUP: 'Select a group',
    TYPE_AN_EMAIL_TO_SEND_INVITATION: 'Type an email to send invitation',
    SELLER_INSTAGRAM_ORGANIC: 'Instagram Organic Post',
    SELLER_INSTAGRAM_ORGANIC_DESC: 'Allows you to make organic posts on Instagram',
    SELLER_CAPTION_GENERATOR: 'Automated Caption Generation',
    SELLER_CAPTION_GENERATOR_DESC: 'Allows for automated caption creation',
  },
};

const UserPT = {
  User: {
    TITLE_ADMINISTRATION: 'Administração de usuários',
    ACCESS_PROFILE: 'Perfil de Acesso',
    USER_MANAGEMENT: 'Gerenciamento',
    FACEBOOK: 'Facebook',
    GUEST: 'Convidado',
    STATUS: 'Status',
    ACTIVE: 'Ativo',
    BLOCKED: 'Bloqueado',
    PENDING_APPROVAL: 'Aguardando confirmação',
    INVITED: 'Convidado',
    TO_BLOCK: 'Bloquear',
    TO_ACTIVATE: 'Ativar',
    TO_REMOVE: 'Remover',
    CANCEL_INVITATION_TITLE: 'Cancelar convite',
    CANCEL_INVITATION_SUBTITLE: 'Deseja realmente excluir o convite?',
    BUTTON_CONFIRM: 'Sim',
    BUTTON_NO: 'Não',
    INVOKE_USER_TITLE: 'Convidar',
    INVOKE_USER_SUBTITLE: 'Quem você quer convidar?',
    SAVE: 'Salvar',
    BUTTON_CANCEL: 'Cancelar',
    EMPLOYEE: 'Colaborador',
    ADMIN: 'Administrador',
    CREATE_USER_SUCCESS_MESSAGE: 'Usuário criado com sucesso!',
    CREATE_USER_ERROR_MESSAGE: 'Falha ao criar o usuário!',
    INVITE_TO_PLATAFORM: 'Convidar para plataforma',
    INVITE_USER_SUCCESS_MESSAGE: 'Convite enviado ao usuário com sucesso!',
    INVITE_USER_ERROR_MESSAGE: 'Falha ao enviar o convite ao usuário!',
    INVITE_USER_ERROR_MESSAGE_USER_ALREADY_EXISTS: 'Este usuário já foi convidado para o sistema.',
    REVOKE_INVITE_SUCCESS_MESSAGE: 'Convite cancelado com sucesso!',
    REVOKE_INVITE_ERROR_MESSAGE: 'Falha ao cancelar envio de convite!',
    EDIT_USER_ROLE_SUCCESS_MESSAGE: 'Função alterada com sucesso!',
    EDIT_USER_ROLE_ERROR_MESSAGE: 'Falha ao alterar a função do usuário!',
    EDIT_USER_GROUP_SUCCESS_MESSAGE: 'Grupo alterado com sucesso!',
    EDIT_USER_GROUP_ERROR_MESSAGE: 'Falha ao alterar a grupo do usuário!',
    EDIT_USER_PERMITTED: 'Editar permissão de usuário',
    ROLE: 'Função',
    ROLE_GROUP: 'Grupo',
    ROLE_EMAIL: 'Email',
    ROOT_GROUPS: 'Todos',
    PLACEHOLDER: 'Procure o grupo',
    NO_FOUND: 'Nenhum resultado encontrado',
    ACTUAL_GROUP: 'Grupo atual',
    NEW_GROUP: 'Novo grupo',
    PERMITTED_GROUPS: 'Grupos permitidos',
    ADD_PERMITTED_GROUPS: 'Adicionar permissão de grupo',
    PENDING: 'Pendente',
    USER_ACCESS_STEP_NOT_STARTED: 'Não iniciado',
    USER_ACCESS_STEP_SET_EMAIL: 'Preenchendo e-mail',
    USER_ACCESS_STEP_SET_PAGE_SCOPED_TOKEN: 'Autenticação de Página',
    USER_ACCESS_STEP_SET_PAGE: 'Seleção de página',
    USER_ACCESS_STEP_SET_PRIVATE_AD_ACCOUNT: 'Seleção de Conta de Anúncios',
    USER_ACCESS_STEP_SET_PRIVATE_AD_ACCOUNT_PAYMENT_METHOD: 'Seleção de método de pagamento',
    USER_ACCESS_STEP_SHOW_PENDING_REQUESTS: 'Aceite de pendências no BM',
    USER_ACCESS_STEP_WAITING_PLATFORM_SETUP: 'Aguardando setup automático na plataforma',
    USER_ACCESS_STEP_PENDING_PLATFORM_INVITATION: 'Aguardando aceite de convite da plataforma',
    USER_ACCESS_STEP_FINISHED: 'Finalizado',
    PENDING: 'Pendente',
    ALL: 'Todos',
    Role: 'Perfil',
    EDIT: 'Editar',
    EDIT_CAPABILITIES_SUCCESS_MESSAGE: 'Permissões alteradas com sucesso!',
    EDIT_CAPABILITIES_ERROR_MESSAGE: 'Falha ao alterar as permissões do usuário!',
    PERMISSIONS: 'Permissões',
    PROFILE: 'Perfil',
    REPORT: 'Relatórios',
    BOOSTED_VIDEO: 'Vídeo impulsionado',
    USERS: 'Gerenciamento de usuários',
    FB_BUSINESS: 'Gerenciador de negócios do Facebook',
    SETTINGS: 'Configurações',
    PINNED_ASSETS: 'Ativos fixados',
    REVIEWS: 'Revisões',
    BATCH_ACTIONS: 'Ações em massa',
    NEWS: 'Notícias',
    REPORT_LIST: 'Lista de relatórios',
    APPROVAL: 'Aprovação automática',
    APPROVAL_DESC: 'Todo conteúdo criado via APP é automaticamente aprovado.',
    EMPTY_CONTENT_MESSAGE: 'Nenhum usuário encontrado.',
    RESEND_INVITE: 'Reenviar convite',
    'BLOCK-USER-TITLE': 'Tem certeza que deseja bloquear este usuário?',
    'BLOCK-USER-BM': 'Excluir usuário do Business Manager',
    'UNBLOCK-USER-TITLE': 'Tem certeza que deseja desbloquear este usuário?',
    'UNBLOCK-USER-BM': 'Adicionar usuário ao Business Manager',
    UNBLOCK: 'Desbloquear',
    TOTAL: 'TOTAL',
    'ACTIVE-SUMMARY': 'ATIVOS',
    'IN-PROGRESS-SUMMARY': 'EM ANDAMENTO',
    'INVITED-SUMMARY': 'CONVIDADOS',
    'BLOCKED-SUMMARY': 'BLOQUEADOS',
    MANAGEMENT: 'Gerenciamento',
    CREATION: 'Criação',
    APP: 'Aplicativo GD',
    CONVERSION_FLOW: 'Fluxo de Conversão',
    CONVERSION_FLOW_DESC: 'Relatório com métricas de conversão',
    ENGAGEMENT: 'Engajamento',
    ENGAGEMENT_DESC: 'Relatório com métricas de engajamento.',
    VIDEO_VIEW: 'Video View',
    VIDEO_VIEW_DESC:
      'Relatório com métricas de resultados da produção de conteúdos em vídeo, engajamento nos vídeos, porcentagem de visualização, entre outras.',
    ACTIVITY: 'Atividade',
    ACTIVITY_DESC:
      'Atividade das lojas no projeto, como a quantidade de conteúdos produzidos, média mensal, porcentual do formato, unidades ativas e usuários conectados.',
    REPORT_RANKING: 'Ranking',
    REPORT_RANKING_DESC:
      'Relatório para comparar o desempenho, em diferentes métricas, das unidades.',
    REPORT_AUDIENCE: 'Audiência',
    REPORT_CUSTOM: 'Personalizado',
    REPORT_COMMENTS: 'Comentários',
    REPORT_COMMENTS_DESC:
      'Relatório de comentários em publicações das unidades, com métricas de tempo e porcentagens de respostas.',
    REPORT_AUDIENCE_DESC: 'Análise de Idade, Gênero, Canais e Dispositivos do público.',
    REPORT_COMMENTS: 'Comentários',
    REPORT_COMMENTS_DESC:
      'Relatório de comentários em publicações das unidades, com métricas de tempo e porcentagens de respostas.',
    LEAD_ADS: 'Lead Ads',
    LEAD_ADS_DESC: 'Relatório de resultados dos anúncios com objetivo de captação de Lead.',
    GENERAL_LISTING: 'Listagem Geral',
    GENERAL_LISTING_DESC:
      'Visualização dos grupos em forma de listagem, com possibilidade de entrada para adaptação da plataforma para os dados daquele grupo.',
    MANAGE_GROUPS: 'Gerenciar Grupos',
    MANAGE_GROUPS_DESC:
      'Permite mover, excluir, renomear um grupo, gerenciar contas e substituir IDs das páginas.',
    TRENDS: 'Trends',
    TRENDS_DESC: 'Visualizar trends',
    MEDIA_SETS_UPLOAD: 'Biblioteca de mídias',
    MEDIA_SETS_UPLOAD_DESC: 'Enviar biblioteca de mídias',
    UNIT_SCORE: 'Score de unidade',
    UNIT_SCORE_DESC: 'Visualizar score de unidade',
    USER_LISTING: 'Listagem de Usuários',
    USER_LISTING_DESC: 'Visualização de todas as contas de usuários.',
    USER_MANAGE: 'Gerenciar Usuários',
    USER_MANAGE_DESC: 'Permite editar permissões de usuários.',
    USER_INVITE: 'Convidar usuário',
    USER_INVITE_DESC: 'Dá a capacidade de adicionar usuários e bloquear usuários ativos.',
    ADACCOUNT_BUDGET: 'Orçamento',
    ADACCOUNT_BUDGET_DESC: 'Visualizar o limite de Orçamento das contas de anúncios.',
    BUDGET_SPEND_CAP: 'Gerenciar orçamento dos grupos',
    BUDGET_SPEND_CAP_DESC: 'Permite depositar ou remover verba das unidades.',
    BATCH_BUDGET_SPEND_CAP: 'Distribuir orçamento em massa',
    BATCH_BUDGET_SPEND_CAP_DESC:
      'Permite que possa distribuir a verba disponível para várias unidades ao mesmo tempo',
    FEED: 'Feed',
    FEED_DESC: 'Acesso ao feed de postagens e anúncios.',
    EDIT_AD: 'Edição de anúncios',
    EDIT_AD_DESC:
      'Permite a edição em: período de veiculação, investimento, objetivo de campanha e pausar anúncios.',
    FEED_AWARDS: 'Ordenar por premiações no Feed',
    FEED_AWARDS_DESC: 'Possibilita ordenar os anúncios por premiação.',
    CDA: 'Criativos Dinâmicos',
    CDA_DESC: 'Permite a distribuição de mídias personalizadas entre as unidades e grupos.',
    BATCH_UPDATE_PROFILE_COVER: 'Mudar perfil e capa em massa',
    BATCH_UPDATE_PROFILE_COVER_DESC:
      'Permite alterar a foto de perfil e capa das páginas pela plataforma.',
    BATCH_PROMOTE: 'Promover',
    BATCH_PROMOTE_DESC: 'Permite promover postagens ou anúncios em massa.',
    BATCH_REPLICATE: 'Replicar',
    BATCH_REPLICATE_DESC: 'Permite replicar postagens ou anúncios em massa.',
    USER_INFO: 'Edição de Perfil de Usuário',
    USER_INFO_DESC: 'Editar meu perfil de usuário no GD.',
    USER_PROFILE: 'Visualizar Perfil de Usuário',
    USER_PROFILE_DESC: 'Visualizar meu perfil de usuário no GD.',
    MEDIA_SETS: 'Biblioteca de Mídias',
    MEDIA_SETS_DESC: 'Permite receber arquivos de mídias na biblioteca.',
    DEFAULT_POST: 'Postagem Default',
    DEFAULT_POST_DESC: 'Marcar postagem default (interno)',
    MEDIA_APPROVAL: 'Controle de conteúdo produzido',
    MEDIA_APPROVAL_DESC: 'Possibilita aprovar ou reprovar a mídia vinda do APP',
    AUTO_APPROVAL: 'Aprovação automática',
    AUTO_APPROVAL_DESC: 'Todo conteúdo criado via APP é automaticamente aprovado.',
    SUGGEST_APPROVAL: 'Tipo de postagem',
    SUGGEST_APPROVAL_DESC:
      'Permite ao usuário do APP poder definir se o conteúdo será pago ou orgânico e configurá-lo',
    REPORT_DESC:
      'Saúde geral da unidade, do grupo ou de todos os grupos, dependendo do nível de acesso do usuário, com orçamentos, impressões, entre outras.',
    REPORT_ITEM: 'Visão Global',
    default_user: 'Colaborador',
    CAPABILITIES: 'Permissões',
    SELLER_REACH: 'Alcance',
    SELLER_REACH_DESC: 'Visualizar as métricas dos anúncios no feed.',
    SELLER_BUDGET_SPEND_CAP: 'Saldo',
    SELLER_BUDGET_SPEND_CAP_DESC: 'Visualizar o saldo da conta.',
    SELLER_MEDIA_SETS: 'Biblioteca de mídias',
    SELLER_MEDIA_SETS_DESC: 'Permite receber arquivos de mídias na biblioteca.',
    SELLER_INSTAGRAM: 'Postagem Instagram',
    SELLER_INSTAGRAM_DESC: 'Permite fazer via APP postagens para o Instagram.',
    SELLER_TARGET_SELECTION: 'Seleção de público',
    SELLER_TARGET_SELECTION_DESC: 'Selecionar público que será alcançado pelo anúncio.',
    SELLER_PICTURE_CHANGE: 'Mudar foto de perfil e capa',
    SELLER_PICTURE_CHANGE_DESC: 'Permite alterar a foto de perfil e capa da página do Facebook.',
    SELLER_WHATSAPP: 'Contato Whatsapp',
    SELLER_WHATSAPP_DESC: 'Permite alterar o número de Whatsapp da página do Facebook.',
    SELLER_VIEW_COMMENTS: 'Comentários',
    SELLER_VIEW_COMMENTS_DESC: 'Visualizar os comentários recebidos na página do Facebook.',
    SELLER_RESPOND_TO_COMMENTS: 'Interação',
    SELLER_RESPOND_TO_COMMENTS_DESC:
      'Permite interagir com os comentários recebidos na página do Facebook.',
    MEDIA_SET_MANAGE: 'Envio e gerenciamento de Mídias',
    MEDIA_SET_MANAGE_DESC:
      'Permite distribuir mídias entre as unidades e grupos; permite também excluir pastas e arquivos.',
    GDTV: 'Visualizar GDTV',
    GDTV_DESC: 'Permite visualizar os conteúdos enviados via GDTV.',
    GDTV_MANAGE: 'Envio de GDTV',
    GDTV_MANAGE_DESC:
      'Permite a distribuição de conteúdos via GDTV. Os conteúdos distribuídos poderão ser vistos no feed do aplicativo pelas unidades.',
    SELLER_CAROUSEL: 'Carrossel',
    SELLER_CAROUSEL_DESC:
      'Possibilidade de criar um único anúncio com até dez imagens ou vídeos, cada mídia com seu próprio título, descrição e link.',
    SELLER_MULTI_IMAGE: 'Multi imagem',
    SELLER_MULTI_IMAGE_DESC: 'Permite fazer postagens e anúncios com mais de uma imagem ou vídeo.',
    VIEW_LEADS_REPORT: 'Visualizar Geração de cadastros',
    VIEW_LEADS_REPORT_DESC:
      'Relatório com resultados dos anúncios com objetivo de geração de cadastros, com métricas de cadastros totais e conversão para cadastro.',
    DOWNLOAD_LEADS_LIST: 'Download da lista de cadastros',
    DOWNLOAD_LEADS_LIST_DESC:
      'Permite baixar a planilha com os dados dos usuários cadastrados a partir da campanha de geração de leads.',
    SELLER_LEADS: 'Geração de Cadastros',
    SELLER_LEADS_DESC: 'Permite criar campanhas com objetivo de geração de cadastros.',
    SELLER_DOWNLOAD_LEADS: 'Download da lista de cadastros',
    SELLER_DOWNLOAD_LEADS_DESC:
      'Permite baixar a planilha com os dados dos usuários cadastrados a partir da campanha de geração de leads no aplicativo.',
    SELLER_VIEW_LEADS_REPORT: 'Visualizar Geração de cadastros',
    SELLER_VIEW_LEADS_REPORT_DESC:
      'Relatório com resultados dos anúncios com objetivo de geração de cadastros, com métricas de cadastros totais e conversão para cadastro.',
    CREATE_INCENTIVE_CAMPAIGN_FIXED_BUDGET: 'Campanhas de incentivo com orçamento fixo',
    CREATE_INCENTIVE_CAMPAIGN_FIXED_BUDGET_DESC:
      'Permite a criação de campanhas de incentivo a partir de um orçamento fixo.',
    REPORT_CUSTOM_DESC: 'Relatório Personalizado',
    CALENDAR: 'Calendário de Ações',
    CALENDAR_DESC:
      'Permite criar, alterar e remover eventos relacionados a conteúdo, publicações, educação e metas.',
    CATEGORIZE_NEW_POST: 'Categorização de produto',
    CATEGORIZE_NEW_POST_DESC:
      'Permite o tagueamento de qual categoria o produto anunciado se enquadra.',
    USERS_FILTERS_INPUT_PLACEHOLDER: 'Pesquise por nome ou email',
    SELECT_ROLE: 'Selecione uma função',
    SELECT_GROUP: 'Selecione um grupo',
    TYPE_AN_EMAIL_TO_INVITE_USER: 'Digite o email para enviar o convite',
    SELLER_INSTAGRAM_ORGANIC: 'Postagem Orgânica Instagram',
    SELLER_INSTAGRAM_ORGANIC_DESC: 'Permite fazer postagens orgânicas no Instagram',
    SELLER_CAPTION_GENERATOR: 'Geração de Legendas Automatizadas',
    SELLER_CAPTION_GENERATOR_DESC: 'Permite criar legendas de forma automatizada',
  },
};

const UserES = {
  User: {
    TITLE_ADMINISTRATION: 'Administración de usuarios',
    ACCESS_PROFILE: 'Perfil de acceso',
    USER_MANAGEMENT: 'Gestión',
    FACEBOOK: 'Facebook',
    GUEST: 'Invitado',
    STATUS: 'Estado',
    ACTIVE: 'Activo',
    BLOCKED: 'Obstruido',
    PENDING_APPROVAL: 'Esperando confirmación',
    INVITED: 'Invitado',
    INVITE_TO_PLATAFORM: 'Invitar a la plataforma',
    TO_BLOCK: 'Cuadra',
    TO_ACTIVATE: 'Activar',
    TO_REMOVE: 'Eliminar',
    CANCEL_INVITATION_TITLE: 'Cancelar invitación',
    CANCEL_INVITATION_SUBTITLE: '¿Realmente quieres eliminar la invitación?',
    BUTTON_CONFIRM: 'Sí',
    BUTTON_NO: 'No',
    INVOKE_USER_TITLE: 'Invitar',
    INVOKE_USER_SUBTITLE: '¿A quién quieres invitar?',
    SAVE: 'Ahorrar',
    BUTTON_CANCEL: 'Cancelar',
    EMPLOYEE: 'Colaborador',
    ADMIN: 'Administrador',
    CREATE_USER_SUCCESS_MESSAGE: '¡Usuario creado con éxito!',
    CREATE_USER_ERROR_MESSAGE: '¡No se pudo crear el usuario!',
    INVITE_USER_SUCCESS_MESSAGE: '¡Invitación enviada al usuario con éxito!',
    INVITE_USER_ERROR_MESSAGE: '¡No se pudo enviar la invitación al usuario!',
    INVITE_USER_ERROR_MESSAGE_USER_ALREADY_EXISTS: 'Este usuario ya ha sido invitado al sistema.',
    REVOKE_INVITE_SUCCESS_MESSAGE: 'Invitación cancelada correctamente.',
    REVOKE_INVITE_ERROR_MESSAGE: '¡No se pudo cancelar el envío de la invitación!',
    EDIT_USER_ROLE_SUCCESS_MESSAGE: '¡Función cambiada con éxito!',
    EDIT_USER_ROLE_ERROR_MESSAGE: '¡No se pudo cambiar la función del usuario!',
    EDIT_USER_GROUP_SUCCESS_MESSAGE: '¡Grupo cambiado con éxito!',
    EDIT_USER_GROUP_ERROR_MESSAGE: '¡No se pudo cambiar el grupo de usuarios!',
    EDIT_USER_PERMITTED: 'Editar permiso de usuario',
    ROLE: 'Rol',
    ROLE_GROUP: 'Grupo',
    ROLE_EMAIL: 'Correo electrónico',
    ROOT_GROUPS: 'Todos',
    PLACEHOLDER: 'Buscar el grupo',
    NO_FOUND: 'Ningún resultado encontrado',
    ACTUAL_GROUP: 'Grupo actual',
    NEW_GROUP: 'Nuevo grupo',
    PERMITTED_GROUPS: 'Grupos permitidos',
    ADD_PERMITTED_GROUPS: 'Agregar permiso de grupo',
    PENDING: 'Pendiente',
    USER_ACCESS_STEP_NOT_STARTED: 'No empezado',
    USER_ACCESS_STEP_SET_EMAIL: 'Rellenando el correo electrónico',
    USER_ACCESS_STEP_SET_PAGE_SCOPED_TOKEN: 'Autenticación de página',
    USER_ACCESS_STEP_SET_PAGE: 'Selección de página',
    USER_ACCESS_STEP_SET_PRIVATE_AD_ACCOUNT: 'Selección de cuenta publicitaria',
    USER_ACCESS_STEP_SET_PRIVATE_AD_ACCOUNT_PAYMENT_METHOD: 'Selección de método de pago',
    USER_ACCESS_STEP_SHOW_PENDING_REQUESTS: 'Aceptación de asuntos pendientes en el BM',
    USER_ACCESS_STEP_WAITING_PLATFORM_SETUP: 'Esperando configuración automática en la plataforma',
    USER_ACCESS_STEP_PENDING_PLATFORM_INVITATION:
      'Esperando la aceptación de la invitación de la plataforma',
    USER_ACCESS_STEP_FINISHED: 'Terminado',
    PENDING: 'Pendiente',
    ALL: 'Todos',
    Role: 'Perfil',
    EDIT: 'Para editar',
    EDIT_CAPABILITIES_SUCCESS_MESSAGE: '¡Permisos cambiados con éxito!',
    EDIT_CAPABILITIES_ERROR_MESSAGE: '¡No se pudieron cambiar los permisos de usuario!',
    PERMISSIONS: 'Permisos',
    PROFILE: 'Perfil',
    REPORT: 'Informes',
    BOOSTED_VIDEO: 'Video mejorado',
    USERS: 'Gestión de usuarios',
    FB_BUSINESS: 'Gerente comercial de Facebook',
    SETTINGS: 'Ajustes',
    PINNED_ASSETS: 'Activos fijos',
    REVIEWS: 'Reseñas',
    BATCH_ACTIONS: 'Acciones masivas',
    NEWS: 'Noticias',
    REPORT_LIST: 'Lista de informes',
    APPROVAL: 'Aprobación automática',
    APPROVAL_DESC: 'Todo el contenido creado a través de la aplicación se aprueba automáticamente.',
    EMPTY_CONTENT_MESSAGE: 'No se encontraron usuarios.',
    RESEND_INVITE: 'Reenviar invitacíon',
    'BLOCK-USER-TITLE': '¿Estás seguro de que quieres bloquear a este usuario?',
    'BLOCK-USER-BM': 'Eliminar usuario de Business Manager',
    'UNBLOCK-USER-TITLE': '¿Estás seguro de que deseas desbloquear a este usuario?',
    'UNBLOCK-USER-BM': 'Agregar usuario al administrador comercial',
    UNBLOCK: 'Desbloquear',
    TOTAL: 'TOTAL',
    'ACTIVE-SUMMARY': 'ACTIVOS',
    'IN-PROGRESS-SUMMARY': 'EN PROCESO',
    'INVITED-SUMMARY': 'INVITADOS',
    'BLOCKED-SUMMARY': 'OBSTRUIDOS',
    MANAGEMENT: 'Gestión',
    CREATION: 'Creación',
    APP: 'Aplicación GD',
    CONVERSION_FLOW: 'Flujo de conversión',
    CONVERSION_FLOW_DESC: 'Informe con métricas de conversión',
    ENGAGEMENT: 'Compromiso',
    ENGAGEMENT_DESC: 'Informe con métricas de participación.',
    VIDEO_VIEW: 'Vista de video',
    VIDEO_VIEW_DESC:
      'Informe con métricas de resultados de producción de contenido de video, participación de video, porcentaje de visualización, entre otros.',
    ACTIVITY: 'Actividad',
    ACTIVITY_DESC:
      'Almacene la actividad en el proyecto, como la cantidad de contenido producido, promedio mensual, porcentaje de formato, unidades activas y usuarios conectados.',
    REPORT_RANKING: 'Clasificación',
    REPORT_RANKING_DESC:
      'Informe para comparar el rendimiento, en diferentes métricas, de las unidades.',
    REPORT_AUDIENCE: 'Audiencia',
    REPORT_CUSTOM: 'Personalizado',
    REPORT_COMMENTS: 'Comentarios',
    REPORT_COMMENTS_DESC:
      'Informe de comentarios sobre publicaciones de las unidades, con métricas de tiempo y porcentajes de respuesta.',
    REPORT_AUDIENCE_DESC: 'Análisis de edad, género, canales y dispositivos de la audiencia.',
    REPORT_COMMENTS: 'Comentarios',
    REPORT_COMMENTS_DESC:
      'Informe de comentarios sobre publicaciones de las unidades, con métricas de tiempo y porcentajes de respuesta.',
    LEAD_ADS: 'Lead Ads',
    LEAD_ADS_DESC: 'Informe de resultados de anuncios con el objetivo de captar un Lead.',
    GENERAL_LISTING: 'Listado general',
    GENERAL_LISTING_DESC:
      'Visualización de grupos en forma de lista, con posibilidad de entrada para adaptar la plataforma a los datos de ese grupo.',
    MANAGE_GROUPS: 'Administrar grupos',
    MANAGE_GROUPS_DESC:
      'Le permite mover, eliminar, cambiar el nombre de un grupo, administrar cuentas y reemplazar ID de página.',
    TRENDS: 'Trends',
    TRENDS_DESC: 'Ver trends',
    MEDIA_SETS_UPLOAD: 'Biblioteca multimedia',
    MEDIA_SETS_UPLOAD_DESC: 'Enviar biblioteca multimedia',
    UNIT_SCORE: 'Puntuación de usuario',
    UNIT_SCORE_DESC: 'Ver puntuación de usuario',
    USER_LISTING: 'Listado de usuarios',
    USER_LISTING_DESC: 'Vista de todas las cuentas de usuario.',
    USER_MANAGE: 'Administrar usuarios',
    USER_MANAGE_DESC: 'Le permite editar los permisos de usuario.',
    USER_INVITE: 'Invitar usuario',
    USER_INVITE_DESC: 'Ofrece la posibilidad de agregar usuarios y bloquear usuarios activos.',
    ADACCOUNT_BUDGET: 'Presupuesto',
    ADACCOUNT_BUDGET_DESC: 'Ver el límite de presupuesto para cuentas publicitarias.',
    BUDGET_SPEND_CAP: 'Administrar el presupuesto de los grupos',
    BUDGET_SPEND_CAP_DESC: 'Le permite depositar o retirar fondos de las unidades.',
    BATCH_BUDGET_SPEND_CAP: 'Distribuir presupuesto masivo',
    BATCH_BUDGET_SPEND_CAP_DESC:
      'Le permite distribuir el presupuesto disponible a varias unidades al mismo tiempo',
    FEED: 'Feed',
    FEED_DESC: 'Acceso a las publicaciones y al feed de anuncios.',
    EDIT_AD: 'Edición de anuncios',
    EDIT_AD_DESC:
      'Permite editar en: período de ubicación, inversión, objetivo de campaña y pausa de anuncios.',
    FEED_AWARDS: 'Ordenar por premios en Feed',
    FEED_AWARDS_DESC: 'Le permite ordenar los anuncios por premio.',
    CDA: 'Creatividades dinámicas',
    CDA_DESC: 'Permite la distribución de medios personalizados entre unidades y grupos.',
    BATCH_UPDATE_PROFILE_COVER: 'Cambiar perfil y cobertura a granel',
    BATCH_UPDATE_PROFILE_COVER_DESC:
      'Le permite cambiar la foto de perfil y la portada de la página por plataforma.',
    BATCH_PROMOTE: 'Promover',
    BATCH_PROMOTE_DESC: 'Le permite promocionar publicaciones o anuncios de forma masiva.',
    BATCH_REPLICATE: 'Reproducir',
    BATCH_REPLICATE_DESC: 'Le permite replicar publicaciones o anuncios de forma masiva.',
    USER_INFO: 'Edición de perfil de usuario',
    USER_INFO_DESC: 'Edite mi perfil de usuario en GD.',
    USER_PROFILE: 'Ver perfil de usuario',
    USER_PROFILE_DESC: 'Ver mi perfil de usuario en GD.',
    MEDIA_SETS: 'Mediateca',
    MEDIA_SETS_DESC: 'Le permite recibir archivos multimedia en la biblioteca.',
    DEFAULT_POST: 'Publicación predeterminada',
    DEFAULT_POST_DESC: 'Marcar publicación predeterminada (interna)',
    MEDIA_APPROVAL: 'Control de contenido producido',
    MEDIA_APPROVAL_DESC: 'Le permite aprobar o desaprobar los medios provenientes de la aplicación',
    AUTO_APPROVAL: 'Aprobación automática',
    AUTO_APPROVAL_DESC:
      'Todo el contenido creado a través de la aplicación se aprueba automáticamente.',
    SUGGEST_APPROVAL: 'Tipo de correo',
    SUGGEST_APPROVAL_DESC:
      'Permite al usuario de la aplicación definir si el contenido será de pago u orgánico y configurarlo',
    REPORT_DESC:
      'Salud general de la unidad, del grupo o de todos los grupos, según el nivel de acceso del usuario, con presupuestos, impresiones, entre otros.',
    REPORT_ITEM: 'Visión global',
    default_user: 'Colaborador',
    CAPABILITIES: 'Permisos',
    SELLER_REACH: 'Alcance',
    SELLER_REACH_DESC: 'Ver métricas de anuncios en el feed.',
    SELLER_BUDGET_SPEND_CAP: 'Saldo',
    SELLER_BUDGET_SPEND_CAP_DESC: 'Ver el saldo de su cuenta.',
    SELLER_MEDIA_SETS: 'Mediateca',
    SELLER_MEDIA_SETS_DESC: 'Le permite recibir archivos multimedia en la biblioteca.',
    SELLER_INSTAGRAM: 'Publicación de Instagram',
    SELLER_INSTAGRAM_DESC: 'Le permite hacer publicaciones en Instagram a través de la aplicación.',
    SELLER_TARGET_SELECTION: 'Selección de audiencia',
    SELLER_TARGET_SELECTION_DESC: 'Seleccione la audiencia a la que llegará el anuncio.',
    SELLER_PICTURE_CHANGE: 'Cambiar foto de perfil y portada',
    SELLER_PICTURE_CHANGE_DESC:
      'Le permite cambiar la foto de perfil y la portada de la página de Facebook.',
    SELLER_WHATSAPP: 'Contacto Whatsapp',
    SELLER_WHATSAPP_DESC: 'Le permite cambiar el número de Whatsapp de la página de Facebook.',
    SELLER_VIEW_COMMENTS: 'Comentarios',
    SELLER_VIEW_COMMENTS_DESC: 'Vea los comentarios recibidos en la página de Facebook.',
    SELLER_RESPOND_TO_COMMENTS: 'Interacción',
    SELLER_RESPOND_TO_COMMENTS_DESC:
      'Le permite interactuar con los comentarios recibidos en la página de Facebook.',
    MEDIA_SET_MANAGE: 'Envío y gestión de medios',
    MEDIA_SET_MANAGE_DESC:
      'Le permite distribuir medios entre unidades y grupos; también le permite eliminar carpetas y archivos.',
    GDTV: 'Ver GDTV',
    GDTV_DESC: 'Le permite ver los contenidos enviados a través de GDTV.',
    GDTV_MANAGE: 'Envío de GDTV',
    GDTV_MANAGE_DESC:
      'Permite la distribución de contenido a través de GDTV. Los contenidos distribuidos se pueden ver en el feed de la aplicación por las unidades.',
    SELLER_CAROUSEL: 'Carrusel',
    SELLER_CAROUSEL_DESC:
      'Posibilidad de crear un solo anuncio con hasta diez imágenes o videos, cada medio con su propio título, descripción y enlace.',
    SELLER_MULTI_IMAGE: 'Multi imagen',
    SELLER_MULTI_IMAGE_DESC: 'Le permite publicar anuncios con más de una imagen o video.',
    VIEW_LEADS_REPORT: 'Ver generación de registro',
    VIEW_LEADS_REPORT_DESC:
      'Informe con resultados publicitarios con el propósito de generar entradas, con métricas de entradas totales y conversión a matrícula.',
    DOWNLOAD_LEADS_LIST: 'Descarga la lista de entradas',
    DOWNLOAD_LEADS_LIST_DESC:
      'Permite descargar la hoja de cálculo con los datos de los usuarios registrados de la campaña de generación de leads.',
    SELLER_LEADS: 'Generación de registros',
    SELLER_LEADS_DESC: 'Le permite crear campañas con el propósito de generar registros.',
    SELLER_DOWNLOAD_LEADS: 'Descarga la lista de entradas',
    SELLER_DOWNLOAD_LEADS_DESC:
      'Permite descargar la hoja de cálculo con los datos de los usuarios registrados de la campaña de generación de leads en la aplicación.',
    SELLER_VIEW_LEADS_REPORT: 'Ver generación de registro',
    SELLER_VIEW_LEADS_REPORT_DESC:
      'Informe con resultados publicitarios con el propósito de generar entradas, con métricas de entradas totales y conversión a matrícula.',
    CREATE_INCENTIVE_CAMPAIGN_FIXED_BUDGET: 'Campañas de incentivos con presupuesto fijo',
    CREATE_INCENTIVE_CAMPAIGN_FIXED_BUDGET_DESC:
      'Permite la creación de campañas de incentivos a partir de un presupuesto fijo.',
    REPORT_CUSTOM_DESC: 'Informe personalizado',
    CALENDAR: 'Calendario de Acciones',
    CALENDAR_DESC:
      'Le permite crear, cambiar y eliminar eventos relacionados con contenido, publicaciones, educación y objetivos.',
    CATEGORIZE_NEW_POST: 'Categorización de productos',
    CATEGORIZE_NEW_POST_DESC:
      'Le permite etiquetar en qué categoría se encuentra el producto anunciado.',
    USERS_FILTERS_INPUT_PLACEHOLDER: 'Busca por nombre o email',
    SELECT_ROLE: 'Seleccione un rol',
    SELECT_GROUP: 'Seleccione un grupo',
    TYPE_AN_EMAIL_TO_SEND_INVITATION: 'Escribe un email para enviar la invitación',
    SELLER_INSTAGRAM_ORGANIC: 'Publicación Orgánica de Instagram',
    SELLER_INSTAGRAM_ORGANIC_DESC: 'Le permite hacer publicaciones orgánicas en Instagram',
    SELLER_CAPTION_GENERATOR: 'Generador Automático de Leyendas',
    SELLER_CAPTION_GENERATOR_DESC: 'Permite la creación automática de leyendas',
  },
};

export { UserEN, UserPT, UserES };
